import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from 'avn/app';
import { Constants } from 'avn/modules/services/constants';

import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

function bootstrap(): void {
  Sentry.init({
    dsn: environment.sentry.dsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: environment.sentry.tracePropagationTargets,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    ignoreErrors: [
      // Google Maps JS API's internal library loader throws this when it can't
      // fetch a library (e.g. "places"). Usually caused by an ad blocker/privacy
      // extension blocking Google's own gen_204 telemetry ping, not an app bug.
      /Could not load ".*"/
    ],
    initialScope: {
      tags: {
        app_name: Constants.APP_NAME
      },
      contexts: {
        app: {
          name: Constants.APP_NAME
        }
      }
    }
  });

  bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => {
    console.error(err);
  });
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
